require('./style.less');

var DropDown = require('../../../../../common/dropDown/dropDownWr');

module.exports = DropDown.extend({
    template: require('./template.hbs'),
    defaultSelector: function() {
        var o = this.options;
        return '[data-doc="' + o.docCollection.indexOf(o.activeDoc) + '"]';
    },
    selectTemplate: function(initialValue) {
        return require('./select.hbs')({
            initialValue: initialValue
        });
    },
    templateOptions: function() {
       return  {
           documents: this.options.docCollection.map(function(d, i) {
               return {
                   val: i,
                   name: d.documentName()
               };
           })
       };
    },
    onChange: function(value, elData) {
        this.options.vChannel.command('changeActiveDoc', elData.doc);
    },
    onBeforeDestroy: function() {
        this.$('*').remove();
        DropDown.prototype.onBeforeDestroy.apply(this, arguments);
    },
    destroy: function() {
        DropDown.prototype.destroy.apply(this, arguments);
        //todo: onChange still holds the reference in the closure of dd settings
        this.el = null;
        this.$el = null;
    }
});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/viewer/views/nav/navBar/docSelect/view.js
 ** module id = 695
 ** module chunks = 0
 **/